var map = {
	"../pages/detail/detail.module": [
		982,
		6
	],
	"../pages/email/email.module": [
		978,
		5
	],
	"../pages/grid-box/grid-box.module": [
		983,
		4
	],
	"../pages/home/home.module": [
		979,
		3
	],
	"../pages/login/login.module": [
		980,
		2
	],
	"../pages/whatsapp/whatsapp.module": [
		981,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 250;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 250
// module chunks = 7